/**
 * Detecta se um conjunto de regras do vee-validate torna o campo obrigatório.
 *
 * Usado pela marcação visual global (asterisco vermelho / "(opcional)") aplicada
 * em src/libs/vee-validate.js. Fica isolado aqui para poder ser testado e para
 * não acoplar a regra de negócio ao patch de render.
 */

// `required_if` fica de fora de propósito: é condicional, e um asterisco fixo
// mentiria para o usuário justamente quando a condição não vale.
const REGRAS_OBRIGATORIAS = ['required'];

export const regrasExigemPreenchimento = (rules) => {
    if (!rules) return false;

    if (typeof rules === 'string') {
        return rules.split('|').some((parte) => {
            const [nome, params] = parte.trim().split(':');
            if (!REGRAS_OBRIGATORIAS.includes(nome)) return false;
            // suporta a forma "required:false"
            return params !== 'false';
        });
    }

    if (typeof rules === 'object') {
        return Object.keys(rules).some((nome) => {
            if (!REGRAS_OBRIGATORIAS.includes(nome)) return false;
            const valor = rules[nome];
            return valor !== false && valor !== null && valor !== undefined;
        });
    }

    return false;
};

export default regrasExigemPreenchimento;
